import { AppAction } from './appAction';
import { AppState } from './appState';
import { combineEpics } from 'redux-observable';
import { EpicsDependencies } from './epicsDependencies';

export const rootEpic = combineEpics<AppAction, AppAction, AppState, EpicsDependencies>();
